import React from "react";
import styles from './SymbolPreviewContianer.module.css'
import ApiService from "../../services/AppService";


export default class SymbolPreviewContainer extends React.PureComponent {
    constructor(props) {
        super(props);
        this.imagePreviewContainer = React.createRef();
        this.imagePreview = React.createRef();
        this.state = {
            previewGraph: null,
        };
    }

    getGraph = () => this.props.graph;

    componentDidMount() {
        this.graphPreviewContainer = window.document.createElement('div');
        const previewGraph = this.initPreviewEditor(this.graphPreviewContainer);
        this.setState({previewGraph});
        this.setupDraggableArea();
        this.updatePreview();
    };

    componentWillUnmount() {
        const {previewGraph} = this.state;
        previewGraph.destroy();
        this.dragSource.removeListeners();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {previewSymbol: symbol, graph} = this.props;
        if (symbol) {
            this.updatePreview();
            this.handleContainerPreview();
        }
    }

    initPreviewEditor = (container) => {
        let previewGraph;
        if (!window.mxClient.isBrowserSupported()) {
            // Displays an error message if the browser is not supported.
            window.mxUtils.error('Browser is not supported!', 200, false);
        } else {
            previewGraph = this.initPreviewGraph(container);
            this.setDefaultStyles(previewGraph);
            new window.mxRubberband(previewGraph);
        }

        return previewGraph;
    };
    setDefaultStyles = (graph) => {
        const {mxConstants} = window;
        let style = graph.getStylesheet().getDefaultVertexStyle();
        style[mxConstants.STYLE_STROKECOLOR] = '#000';
        let edgeStyle = graph.getStylesheet().getDefaultEdgeStyle();
        edgeStyle['edgeStyle'] = 'wireEdgeStyle';
        edgeStyle[mxConstants.STYLE_ENDARROW] = 0;

        // Adds cells to the model in a single step
        graph.getModel().beginUpdate();
        try {
            //Define styles for each mxCell (vertext and edge) that make up the schematic
            let container_style = new Object();
            container_style[mxConstants.STYLE_ENDARROW] = '0';
            container_style[mxConstants.STYLE_EDITABLE] = '0';
            container_style[mxConstants.STYLE_MOVABLE] = 1;
            container_style[mxConstants.STYLE_FOLDABLE] = 0;
            container_style[mxConstants.STYLE_BENDABLE] = '0';
            container_style[mxConstants.STYLE_RESIZABLE] = '0';
            container_style[mxConstants.STYLE_ROTATABLE] = '0';
            container_style[mxConstants.STYLE_DELETABLE] = '0';
            container_style[mxConstants.STYLE_STROKECOLOR] = 'transparent';
            container_style[mxConstants.STYLE_FONTCOLOR] = '#000000';
            container_style[mxConstants.STYLE_FILLCOLOR] = 'transparent';
            container_style[mxConstants.STYLE_FONTSIZE] = 30;
            container_style[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_LEFT;
            container_style[mxConstants.STYLE_VERTICAL_ALIGN] = mxConstants.ALIGN_BOTTOM;
            graph.getStylesheet().putCellStyle('container_style', container_style);


            let PinNumber_style = new Object();
            PinNumber_style[mxConstants.STYLE_ENDARROW] = '0';
            PinNumber_style[mxConstants.STYLE_EDITABLE] = '1';
            PinNumber_style[mxConstants.STYLE_MOVABLE] = 1;
            PinNumber_style[mxConstants.STYLE_FOLDABLE] = 0;
            PinNumber_style[mxConstants.STYLE_BENDABLE] = '0';
            PinNumber_style[mxConstants.STYLE_RESIZABLE] = '0';
            PinNumber_style[mxConstants.STYLE_ROTATABLE] = '0';
            PinNumber_style[mxConstants.STYLE_DELETABLE] = '0';
            PinNumber_style[mxConstants.STYLE_STROKECOLOR] = 'transparent';
            PinNumber_style[mxConstants.STYLE_FONTCOLOR] = '#000000';
            PinNumber_style[mxConstants.STYLE_FILLCOLOR] = '#DDDDDD';
            PinNumber_style[mxConstants.STYLE_FONTSIZE] = 14;
            PinNumber_style[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_LEFT;
            PinNumber_style[mxConstants.STYLE_VERTICAL_ALIGN] = mxConstants.ALIGN_MIDDLE;
            graph.getStylesheet().putCellStyle('PinNumber_style', PinNumber_style);

            let boundary_style = new Object();
            boundary_style[mxConstants.STYLE_ENDARROW] = '0';
            boundary_style[mxConstants.STYLE_EDITABLE] = '0';
            boundary_style[mxConstants.STYLE_MOVABLE] = 0;
            boundary_style[mxConstants.STYLE_FOLDABLE] = 0;
            boundary_style[mxConstants.STYLE_BENDABLE] = '0';
            boundary_style[mxConstants.STYLE_RESIZABLE] = '0';
            boundary_style[mxConstants.STYLE_ROTATABLE] = '0';
            boundary_style[mxConstants.STYLE_DELETABLE] = '0';
            boundary_style[mxConstants.STYLE_STROKECOLOR] = '#000000';
            boundary_style[mxConstants.STYLE_FONTCOLOR] = '#000000';
            boundary_style[mxConstants.STYLE_FILLCOLOR] = 'transparent';
            graph.getStylesheet().putCellStyle('boundary_style', boundary_style);

            let style = new Object();
            style[mxConstants.STYLE_ENDARROW] = '0';
            style[mxConstants.STYLE_EDITABLE] = '0';
            style[mxConstants.STYLE_MOVABLE] = 0;
            style[mxConstants.STYLE_FOLDABLE] = 0;
            style[mxConstants.STYLE_BENDABLE] = '0';
            style[mxConstants.STYLE_RESIZABLE] = '0';
            style[mxConstants.STYLE_ROTATABLE] = '0';
            style[mxConstants.STYLE_DELETABLE] = '0';
            style[mxConstants.STYLE_STROKECOLOR] = '#000000';
            style[mxConstants.STYLE_FONTCOLOR] = '#000000';
            style[mxConstants.STYLE_FILLCOLOR] = 'transparent';
            style[mxConstants.STYLE_PORT_CONSTRAINT] = 0;
            graph.getStylesheet().putCellStyle('symbol_style', style);

            let Line_style = new Object();
            Line_style[mxConstants.STYLE_ENDARROW] = 'mxConstants.ARROW_OVAL';
            Line_style[mxConstants.STYLE_STARTARROW] = mxConstants.ARROW_OVAL;
            Line_style[mxConstants.STYLE_ENDSIZE] = 0.1;
            Line_style[mxConstants.STYLE_STARTSIZE] = 0.1;
            Line_style[mxConstants.STYLE_EDITABLE] = 0;
            Line_style[mxConstants.STYLE_MOVABLE] = 0;
            Line_style[mxConstants.STYLE_FOLDABLE] = 0;
            Line_style[mxConstants.STYLE_BENDABLE] = 0;
            Line_style[mxConstants.STYLE_RESIZABLE] = 0;
            Line_style[mxConstants.STYLE_ROTATABLE] = 0;
            Line_style[mxConstants.STYLE_DELETABLE] = 0;
            Line_style[mxConstants.STYLE_STROKECOLOR] = '#000000';
            graph.getStylesheet().putCellStyle('Line_Style', Line_style);

            let Pin_style = new Object();
            Pin_style[mxConstants.STYLE_ENDARROW] = mxConstants.ARROW_OVAL;
            Pin_style[mxConstants.STYLE_STARTARROW] = mxConstants.ARROW_OVAL;
            Pin_style[mxConstants.STYLE_ENDSIZE] = 0.1;
            Pin_style[mxConstants.STYLE_STARTSIZE] = 0.1;
            Pin_style[mxConstants.STYLE_EDITABLE] = 0;
            Pin_style[mxConstants.STYLE_MOVABLE] = 0;
            Pin_style[mxConstants.STYLE_FOLDABLE] = 0;
            Pin_style[mxConstants.STYLE_BENDABLE] = 0;
            Pin_style[mxConstants.STYLE_RESIZABLE] = 0;
            Pin_style[mxConstants.STYLE_ROTATABLE] = 0;
            Pin_style[mxConstants.STYLE_DELETABLE] = 0;
            Pin_style[mxConstants.STYLE_STROKECOLOR] = '#AA0000';
            graph.getStylesheet().putCellStyle('Pin_style', Pin_style);

            let Connection_Style = new Object();
            Connection_Style[mxConstants.STYLE_EDGE] = mxConstants.EDGESTYLE_SEGMENT;
            Connection_Style[mxConstants.STYLE_ENDARROW] = 0;
            Connection_Style[mxConstants.STYLE_DELETABLE] = 0;
            Connection_Style[mxConstants.STYLE_STROKECOLOR] = '#4444AA';
            graph.getStylesheet().putCellStyle('Connection_Style', Connection_Style);
            graph.foldingEnabled = false;
            graph.setCellsResizable(false);
        } finally {
            // Updates the display
            graph.getModel().endUpdate();
        }

        graph.centerZoom = true;
    };

    updatePreview = () => {
        const {previewGraph} = this.state;
        const {previewSymbol: symbol} = this.props;
        const imagePadding = 20;
        let pt = {
            x: imagePadding,
            y: imagePadding
        };

        if (previewGraph) {
            previewGraph.getModel().beginUpdate();
            try {
                /**
                 * Render preview object on hidden mxGraph instance
                 */
                const parentElement = previewGraph.getDefaultParent();
                const geometry = new window.mxGeometry(pt.x, pt.y, symbol.data.X_Bound, symbol.data.Y_Bound);
                const symbolCell = new window.CYNYSymbol(geometry, 'shape=symbol_element;', symbol.data, previewGraph);
                previewGraph.addCell(symbolCell, parentElement);
            } finally {
                previewGraph.getModel().endUpdate();
                /**
                 * Generate object image data from hidden mxGraph instance SVG element
                 */
                const svg = this.graphPreviewContainer.querySelector('svg');
                let clonedSvgElement = svg.cloneNode(true);
                this.imagePreview.current.style.height = symbol.data.Y_Bound + imagePadding * 2 + 'px';
                this.imagePreview.current.style.width = symbol.data.X_Bound + imagePadding * 2 + 'px';
                this.imagePreview.current.innerHTML = '';
                this.imagePreview.current.appendChild(clonedSvgElement);
                previewGraph.getModel().clear();
            }
        }
    };


    setupDraggableArea = () => {
        this.dragSource = window.mxUtils.makeDraggable(this.imagePreview.current, this.getGraph, (graph, evt, cell, x, y) => {
            const {previewSymbol: symbol, setSchematicElement, schematicList} = this.props;
            ApiService.place_symbol(graph, evt, cell, x, y, symbol, setSchematicElement, schematicList)
        }, null, 0, 0);
    };

    initPreviewGraph = (container) => {
        const previewGraph = new window.mxGraph(container);
        previewGraph.useCssTransforms = false;
        previewGraph.setEnabled(true);
        previewGraph.validateViewBackground();
        return previewGraph;
    };

    handleContainerPreview = () => {
        const containerWidth = this.imagePreviewContainer.current.clientWidth;
        const containerHeight = this.imagePreviewContainer.current.clientHeight;
        const imageHeight = this.imagePreview.current.offsetHeight;
        const imageWidth = this.imagePreview.current.offsetWidth;
        const minPadding = 20;
        if (containerWidth >= (imageWidth + minPadding * 2)) {
            const padding = (containerWidth - imageWidth) / 2
            this.imagePreviewContainer.current.style.paddingLeft = `${padding}px`
            this.imagePreviewContainer.current.style.paddingRight = `${padding}px`
        } else {
            this.imagePreviewContainer.current.style.paddingLeft = `${minPadding}px`
            this.imagePreviewContainer.current.style.paddingRight = `${minPadding}px`
        }


        if (containerHeight >= (imageHeight + minPadding * 2)) {
            const padding = (containerHeight - imageHeight) / 2
            this.imagePreviewContainer.current.style.paddingTop = `${padding}px`;
            this.imagePreviewContainer.current.style.paddingBottom = `${padding}px`
        } else {
            this.imagePreviewContainer.current.style.paddingTop = `${minPadding}px`
            this.imagePreviewContainer.current.style.paddingBottom = `${minPadding}px`
        }
    }

    render() {
        return (
            <div className={styles.symbol_container}>
                <div className={styles.pinout_title}>
                    <span>SYMBOL PREVIEW</span>
                </div>
                <div ref={this.imagePreviewContainer}
                     className={styles.symbol_preview_window}>
                    <div className={styles.none_selection} ref={this.imagePreview}></div>
                </div>
            </div>
        )
    }
}
